import { render, staticRenderFns } from "./BudgetLineRequestQuickViewModal.vue?vue&type=template&id=70536ca4&scoped=true"
import script from "./BudgetLineRequestQuickViewModal.vue?vue&type=script&lang=js"
export * from "./BudgetLineRequestQuickViewModal.vue?vue&type=script&lang=js"
import style0 from "./BudgetLineRequestQuickViewModal.vue?vue&type=style&index=0&id=70536ca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70536ca4",
  null
  
)

export default component.exports